"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const react_1 = require("react");
const useFeatureFlag_1 = require("../../../hooks/useFeatureFlag");
const getCyclePeriodDate_1 = require("../../../utils/helpers/cycle/getCyclePeriodDate");
const utils_1 = require("../../utils");
const brand_provider_1 = require("../../../providers/brand.provider");
function CampaignBanner({ show = false, featureFlagKey, catalogSlug, css, floraSection, }) {
    var _a;
    const isMobile = (0, flora_react_1.useIsMobile)();
    const [bannerConfig, loading] = (0, useFeatureFlag_1.useFeatureFlag)(featureFlagKey, null);
    const [bannerConfigParsed, setBannerConfigParsed] = (0, react_1.useState)(null);
    const [url, setUrl] = (0, react_1.useState)(null);
    const [isCampaignPeriod, setIsCampaignPeriod] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (loading || !bannerConfig) {
            return;
        }
        const parsedConfig = (0, utils_1.parseAndGetKeyValueConfig)(bannerConfig, {
            key: brand_provider_1.BrandProvider.getBrand(),
            schema: utils_1.campaignBannerConfigSchema,
        });
        if (!parsedConfig) {
            return;
        }
        setBannerConfigParsed(parsedConfig);
        const generatedUrl = (0, utils_1.buildBannerLink)(parsedConfig, catalogSlug);
        setUrl(generatedUrl);
        const campaignPeriod = (0, getCyclePeriodDate_1.getCyclePeriodDate)(parsedConfig.startDate.toISOString(), parsedConfig.endDate.toISOString());
        setIsCampaignPeriod(campaignPeriod);
    }, [bannerConfig, catalogSlug]);
    const shouldShow = show &&
        bannerConfigParsed &&
        isCampaignPeriod &&
        (isMobile || (!isMobile && bannerConfigParsed.desktopImage));
    const imageSrc = !isMobile && (bannerConfigParsed === null || bannerConfigParsed === void 0 ? void 0 : bannerConfigParsed.desktopImage)
        ? bannerConfigParsed.desktopImage
        : bannerConfigParsed === null || bannerConfigParsed === void 0 ? void 0 : bannerConfigParsed.image;
    const imageCommonProps = {
        fit: 'contain',
        src: imageSrc,
        alt: '',
        css: {
            width: '100%',
            height: '100%',
            maxWidth: '100vw',
            pointerEvents: 'none',
        },
    };
    const commonProps = {
        'autotagging-flora': 'on',
        'data-flora-text': (_a = bannerConfigParsed === null || bannerConfigParsed === void 0 ? void 0 : bannerConfigParsed.label) !== null && _a !== void 0 ? _a : '',
        'data-flora': 'button',
        'data-autotagging-flora-section': floraSection,
        justify: 'center',
        css,
    };
    if (!shouldShow)
        return null;
    if (url) {
        return ((0, jsx_runtime_1.jsx)(flora_react_1.Flex, Object.assign({ as: "a", href: url, "aria-label": bannerConfigParsed.label }, commonProps, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Image, Object.assign({}, imageCommonProps, { "aria-hidden": true })) })));
    }
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Flex, Object.assign({}, commonProps, { as: "div" }, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Image, Object.assign({}, imageCommonProps, { alt: bannerConfigParsed.label })) })));
}
exports.CampaignBanner = CampaignBanner;
